import { useEffect,useState } from 'react';
import { KTIcon } from '../../../../../_metronic/helpers';
import axios from 'axios';
import { RolesUpdateCreate } from './Components.tsx/ModalRoles';
import { useNavigate } from 'react-router-dom';
import { getRolesList,getRolesListglobal } from './request/request';
import { useAppSelector } from '../../../../../redux/hooks';
import Swal from 'sweetalert2';
import { useAuth } from '../../../auth';

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number |string

function RolesCrud() {
    const{currentUser}= useAuth()
    const tenant= useAppSelector(state =>state.TenantSlice.id)



    /* variable para el modal  */
    const [ ID , setID]=useState<ID>(undefined)
    /*__________________________*/

    const navigate= useNavigate()
    const [records,setRecords]= useState<any|null>([ ])

    
   


    /**********************Llamada a axios y parse de data**********************/

    useEffect( () => {
      if (currentUser?.ListPermiso?.includes('Roles.List')){
         if(tenant ===0){
            getRolesList().then(response=>{
                setRecords(response.data)
            })
         }
         else if(tenant !==0){
            getRolesListglobal(tenant).then(response=>{
                setRecords(response.data)
            })
         }
        }
        }, [tenant])

     

    /***********************************************************************************/
  
    



    return(
        <>
        <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>Roles Management</span>
            </h3>
            {/*Se agrega Boton para agregar usuarios*/}
            <div className='card-toolbar'>
                {currentUser?.ListPermiso?.includes('Roles.Create') && <button onClick={ () => setID(null)} className='btn-light-marino f-parrafo'> Add +</button>}
            </div>
            
        </div>

        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
            <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                {/* begin::Table container */}
                <div className='table-responsive'>

                {/* begin::Table */}
                    <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                        {/* begin::Table head */}
                        <thead>
                
                            <tr className="text-azul text-left">
                                <th className='table-cell'>Name</th>
                                <th className='table-cell'>Description</th>
                                <th className='table-cell'>Actions</th>
                            </tr>
                        </thead>
                        {/* end::Table head */}


                        {/* begin::Table body */}
                        <tbody>

                        <tr key={'admin'} className='table-row'> 
                           
                           <td className='table-cell'>Admin</td>
                           <td className='table-cell'>Admin</td>
                           <td className='table-cell'>
                                            <a
                                                href='#'
                                                className='btn btn-light btn-active-light-primary btn-sm'
                                                data-kt-menu-trigger='click'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                Actions
                                                <KTIcon iconName='down' className='fs-5 m-0' />
                                            </a>
                                            {/* begin::Menu */}
                                            <div
                                                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px'
                                                data-kt-menu='true'
                                            >
                                                {/* begin::Menu item */}
                                               { currentUser?.ListPermiso?.includes('Roles.Update') && <div className='menu-item px-3 text-secondary'>
                                                <button className='btn light-primary' 
                                                    
                                                   onClick={ () => setID('adminrol')}>
                                                   View
                                                </button>
                                                </div>}
                                                {/* end::Menu item */}

                                               
                                            </div>
                                      
                                        </td>
                       </tr>
                            
                            {records.map((d:any,i:any)=>(
                                    <tr key={i} className='table-row'> 
                           
                                        <td className='table-cell'>{d.name}</td>
                                        <td className='table-cell 'style={{maxWidth:'100px'}}>{d.description}</td>
                                        <td className='table-cell' >
                                            <a
                                                href='#'
                                                className='btn btn-light btn-active-light-primary btn-sm'
                                                data-kt-menu-trigger='click'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                Actions
                                                <KTIcon iconName='down' className='fs-5 m-0' />
                                            </a>
                                            {/* begin::Menu */}
                                            <div
                                                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px'
                                                data-kt-menu='true'
                                            >
                                                {/* begin::Menu item */}
                                               { currentUser?.ListPermiso?.includes('Roles.Update') && <div className='menu-item px-3 text-secondary'>
                                                <button className='btn light-primary' 
                                                    
                                                   onClick={ () => setID(d.id)}>
                                                    Edit
                                                </button>
                                                </div>}
                                                {/* end::Menu item */}

                                                {/* begin::Menu item */}
                                                {currentUser?.ListPermiso?.includes('Roles.Delete') &&<div className='menu-item px-3'>
                                                <button
                                                    className='btn light-primary '
                                                    onClick={e=> handleSubmit(d.id)}
                                                    data-kt-users-table-filter='delete_row'
                                                
                                                >
                                                    Delete
                                                </button>
                                                </div>}
                                                {/* end::Menu item */}
                                            </div>
                                      
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                          {/* end::Table body */}

                    </table>
                     {/* end::Table */}
                </div>
               

            </div>
            {/* end::Tap pane */}
            </div>
        </div>
        <br />
        {/* end::Body */}
        </div>
        
        {ID !== undefined && <RolesUpdateCreate setID={setID} id={ID} />}

        
        </>

	);
    function handleSubmit(id:any){
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Role!",
            showCancelButton:true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          })
          .then((result) => {
            if (result.isConfirmed) {
                if(tenant===0){
                    axios.delete(API_URL+'/v1/rol/'+id)
                    .then(res=>{
                    if  (res.data.status==='successful'){
                    Swal.fire(
                        'Deleted!',
                        'Your Role has been deleted.',
                        'success'
                    );}
                    else{
                        Swal.fire(
                            'error!',
                            'your role could not be eliminated!',
                            'error'
                        );
                    }
                    getRolesList().then(response=>{
                        setRecords(response.data)
                    })
                })
                   

                }
                else{
                    axios.delete(API_URL+'/v1/rol/'+id+'?tenantId='+tenant)
                    .then(res=>{
                        if  (res.data.status==='successful'){
                            Swal.fire(
                                'Deleted!',
                                'Your Role has been deleted.',
                                'success'
                            );}
                            else{
                                Swal.fire(
                                    'error!',
                                    'your role could not be eliminated!',
                                    'error'
                                );
                            }
                    getRolesListglobal(tenant).then(response=>{
                        setRecords(response.data)
                    })
                })
                
                }
             
            } else {
              Swal.fire({title:"Your Role is safe!", icon: "success"});
            }
          });
        
        
    }
    }

export default RolesCrud